import { PageSettingsModel, SortSettingsModel } from '@syncfusion/ej2-angular-grids';

export interface GridConfig {
	pageSettings?: PageSettingsModel;
	sortSettings?: SortSettingsModel;
}
